import {useState} from "react"
import {Input} from "../ui/input"
import {Button} from "../ui/button"
import Menu from "lucide-react/dist/esm/icons/menu";
import X from "lucide-react/dist/esm/icons/x";
import ShoppingCart from "lucide-react/dist/esm/icons/shopping-cart";
import {Link, useNavigate} from "react-router-dom"
import {useSelector, useDispatch} from "react-redux"
import {logout} from "../../slices/authSlice"

export default function Header() {
    const navigate = useNavigate()
    const [search, setSearch] = useState("")
    const [menuOpen, setMenuOpen] = useState(false)
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)
    const dispatch = useDispatch()
    const cartItems = useSelector((state) => state.cart.items)
    const cartQuantity = cartItems?.reduce((sum, item) => sum + item.quantity, 0) || 0

    const handleLogout = () => {
        dispatch(logout())
        setMenuOpen(false)
        navigate("/")
    }

    const handleLogin = () => {
        setMenuOpen(false)
        navigate("/login")
    }

    const handleSearchSubmit = (e) => {
        if (e.key === "Enter" && search.trim()) {
            const query = new URLSearchParams({q: search.trim()}).toString()
            navigate(`/search?${query}`)
        }
    }

    return (
        <header className="flex flex-col bg-primary text-text-headerfooter sticky z-50 top-0 p-0">
            <div className="flex items-center justify-between p-2 gap-2">
                <Link to="/" className="text-xl font-bold hover:underline"
                      aria-label={`Home Page`}>
                    Queetstone
                </Link>

                <div className="flex-1 mx-4">
                    <Input
                        type="text"
                        placeholder="Search products..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={handleSearchSubmit}
                        className="w-full text-text-headerfooter"
                    />
                </div>

                <div className="flex items-center gap-4">
                    <Link to="/cart" className="relative"
                          aria-label={`Shopping cart${cartQuantity > 0 ? `, ${cartQuantity} items` : ''}`}>

                        <ShoppingCart/>

                        {cartQuantity > 0 && (
                            <span className="absolute -top-3 -right-2
                                            bg-red-600 text-text-headerfooter text-xs
                                            w-5 h-5 rounded-full
                                            flex items-center justify-center">
                        {cartQuantity}
                            </span>
                        )}
                    </Link>

                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => setMenuOpen(true)}
                        aria-label="Open Menu"
                    >
                        <Menu/>
                    </Button>
                </div>
            </div>

            <nav className="text-lg px-4 pb-2 overflow-x-auto whitespace-nowrap scroll-smooth hide-scrollbar">
                <div className="inline-flex gap-10">
                    <Link to="/products/Gift%20Collection" className="hover:underline">
                        Gift Collection
                    </Link>
                    <Link to="/products/Clothing/T-Shirts" className="hover:underline">
                        T-Shirts
                    </Link>
                    <Link to="/products/Pets" className="hover:underline">
                        Pets
                    </Link>
                    <Link to="/products/Gift%20Collection/Under%20%2430" className="hover:underline">
                        Under $30
                    </Link>
                    <Link to="/products/Fitness/Yoga" className="hover:underline">
                        Yoga
                    </Link>
                    <Link to="/products/Gift%20Collection/Artistic" className="hover:underline">
                        Artistic
                    </Link>
                    <Link to="/products/Gift%20Collection/Kitchen" className="hover:underline">
                        Kitchen
                    </Link>
                </div>
            </nav>

            {menuOpen && (
                <div className="fixed inset-0 bg-primary text-text-headerfooter flex flex-col z-50">
                    <div className="flex items-center justify-between p-4">
                        <div className="text-xl font-bold">Menu</div>
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => setMenuOpen(false)}
                            aria-label="Close Menu"
                        >
                            <X/>
                        </Button>
                    </div>

                    <div className="flex flex-col items-center gap-4 p-4 text-lg">
                        <Link to="/" onClick={() => setMenuOpen(false)} className="hover:underline">
                            Home
                        </Link>
                        <Link to="/cart" onClick={() => setMenuOpen(false)} className="hover:underline">
                            Cart
                        </Link>
                        {isLoggedIn && (
                            <div className="flex flex-col gap-4 items-center">
                                <Link to="/account" onClick={() => setMenuOpen(false)} className="hover:underline">
                                    Account
                                </Link>
                                <Link
                                    to="/accountaddresses"
                                    onClick={() => setMenuOpen(false)}
                                    className="hover:underline"
                                >
                                    Addresses
                                </Link>
                                <Link
                                    to="/storedpayments"
                                    onClick={() => setMenuOpen(false)}
                                    className="hover:underline"
                                >
                                    Stored Payments
                                </Link>
                                <Link to="/orders" onClick={() => setMenuOpen(false)} className="hover:underline">
                                    Orders
                                </Link>
                            </div>
                        )}
                    </div>

                    <div className="p-4 border-t border-white/20 mt-auto">
                        {isLoggedIn ? (
                            <Button variant="menu" onClick={handleLogout}>
                                Logout
                            </Button>
                        ) : (
                            <Button variant="menu" onClick={handleLogin}>
                                Login or Register
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </header>
    )
}
